import { useNavigate } from 'react-router-dom';
import { useTodaysRegistrations } from '@/hooks/use-todays-registrations';
import { Button } from '@/components/ui/button';
import { Calendar, Activity } from 'lucide-react';

const TodaysRegistrations = () => {
  const navigate = useNavigate();
  const { count, isLoading } = useTodaysRegistrations();

  const handleClick = () => {
    const today = new Date().toISOString().split('T')[0];
    navigate(`/registrations?date=${today}`);
  };

  return (
    <div className="mb-6 p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      <div className="flex items-center gap-3">
        <Activity className="h-5 w-5 text-primary" />
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Today's registrations:
        </span>
        <Button
          variant="link"
          onClick={handleClick}
          className="p-0 h-auto font-semibold text-primary hover:text-primary/80"
          disabled={isLoading}
        >
          {isLoading ? '...' : count}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={handleClick}
          className="ml-auto"
        >
          <Calendar className="h-4 w-4 mr-2" />
          View Details
        </Button>
      </div>
    </div>
  );
};

export default TodaysRegistrations;